import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PacsButton } from '@/components/common/PacsButton';

import Button, { ButtonEnums } from '../Button';

const Footer = ({ actions, className, onSubmit, value }) => {
  const flex = 'flex items-center justify-end';
  const padding = 'pt-[20px]';

  return (
    <div className={classNames(flex, padding, className)}>
      {actions?.map((action, index) => {
        const isFirst = index === 0;

        const onClickHandler = event => onSubmit({ action, value, event });

        return (
          <PacsButton
            key={index}
            name={action.text}
            className={classNames('min-w-[65px]', { 'ml-[8px]': !isFirst }, action.classes)}
            onClick={onClickHandler}
            theme={isFirst ? 'cancel' : 'primary'}
          >
            {action.text}
          </PacsButton>
        );
      })}
    </div>
  );
};

const noop = () => {};

Footer.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      value: PropTypes.any,
      type: PropTypes.oneOf([ButtonEnums.type.primary, ButtonEnums.type.secondary]).isRequired,
      classes: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
};

Footer.defaultProps = {
  onSubmit: noop,
  actions: [],
};

export default Footer;
